import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ViewComfyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"view_comfy"}/>
}
